import { VacuumAlloy } from "../core/alloy-types";
import { VacuumState } from "../vacuum/vacuum-state";
import * as _ from "lodash";
import Fuse from "fuse.js";

export function filteredProducts(
  products: VacuumAlloy[],
  state: VacuumState
): VacuumAlloy[] {
  const fuse = new Fuse(products, {
    keys: ['category', 'cannonMuskegonTitle', 'aerospaceMaterialSpecifications', 
           'prattAndWhitney', 'generalElectric', 'rollsRoycePlc', 'rollsRoyceCorp', 
           'honeywell', 'safran', 'carbon', 'cobalt', 'chromium', 'tungsten', 'niobium', 
           'tantalum', 'titanium', 'aluminum', 'boron', 'zirconium', 'hafnium', 'iron', 
           'rhenium', 'other', 'densityMetric', 'densityImperial', 'solidusF', 
           'liquidousF', 'solidusC', 'liquidousC' ],
    threshold: 0.4
  });

  const searchTerm = state.searchTerm;
  if (typeof(searchTerm) === "string") {
    products = fuse.search(searchTerm).map(({ item }) => item);
  }

  let currentCategories = state.selectedCategories.filter(cat => cat.selected);
  let categoryFiltered = products.filter(p => {
    return currentCategories.map(c => c.value).includes(p.category);
  });

  let industryFiltered = filteredByIndustryName(categoryFiltered, state);

  let cobaltFiltered = state.cobaltFilterSet
    ? industryFiltered.filter(
        p =>
          p.cobalt != null &&
          p.cobalt <= state.cobaltMax &&
          p.cobalt >= state.cobaltMin
      )
    : industryFiltered;

  let chromiumFiltered = state.chromiumFilterSet
    ? cobaltFiltered.filter(
        p =>
          p.chromium != null &&
          p.chromium <= state.chromiumMax &&
          p.chromium >= state.chromiumMin
      )
    : cobaltFiltered;

  let niobiumFiltered = state.niobiumFilterSet
    ? chromiumFiltered.filter(
        p =>
          p.niobium != null &&
          p.niobium <= state.niobiumMax &&
          p.niobium >= state.niobiumMin
      )
    : chromiumFiltered;

  let tantalumFiltered = state.tantalumFilterSet
    ? niobiumFiltered.filter(
        p =>
          p.tantalum != null &&
          p.tantalum <= state.tantalumMax &&
          p.tantalum >= state.tantalumMin
      )
    : niobiumFiltered;

  let rheniumFiltered = state.rheniumFilterSet
    ? tantalumFiltered.filter(
        p =>
          p.rhenium != null &&
          p.rhenium <= state.rheniumMax &&
          p.rhenium >= state.rheniumMin
      )
    : tantalumFiltered;

  return rheniumFiltered;
}

function filteredByIndustryName(
  products: VacuumAlloy[],
  state: VacuumState
): VacuumAlloy[] {
  // if any filters are set, OR selections together
  if (
    0 < state.cannonMuskegonTitleSelections.length ||
    0 < state.aerospaceMaterialSpecificationsSelections.length ||
    0 < state.prattAndWhitneySelections.length ||
    0 < state.generalElectricSelections.length ||
    0 < state.rollsRoycePlcSelections.length ||
    0 < state.rollsRoyceCorpSelections.length ||
    0 < state.honeywellSelections.length ||
    0 < state.safranSelections.length
  ) {

    let cmFiltered =
      0 < state.cannonMuskegonTitleSelections.length
        ? products.filter(
            p =>
              p.cannonMuskegonTitle &&
              state.cannonMuskegonTitleSelections.includes(
                p.cannonMuskegonTitle
              )
          )
        : [];

    let amsFiltered =
      0 < state.aerospaceMaterialSpecificationsSelections.length
        ? products.filter(
            p => 
              p.aerospaceMaterialSpecifications &&
              state.aerospaceMaterialSpecificationsSelections.includes(
                p.aerospaceMaterialSpecifications.toString()
              )
          )
        : [];

    let prattAndWhitneyFiltered =
      0 < state.prattAndWhitneySelections.length
        ? products.filter(
            p =>
              p.prattAndWhitney &&
              state.prattAndWhitneySelections.includes(p.prattAndWhitney)
          )
        : [];

    let generalElectricFiltered =
      0 < state.generalElectricSelections.length
        ? products.filter(
            p =>
              p.generalElectric &&
              state.generalElectricSelections.includes(p.generalElectric)
          )
        : [];

    let rollsRoycePlcFiltered =
      0 < state.rollsRoycePlcSelections.length
        ? products.filter(
            p =>
              p.rollsRoycePlc &&
              state.rollsRoycePlcSelections.includes(p.rollsRoycePlc)
          )
        : [];

    let rollsRoyceCorpFiltered =
      0 < state.rollsRoyceCorpSelections.length
        ? products.filter(
            p =>
              p.rollsRoyceCorp &&
              state.rollsRoyceCorpSelections.includes(p.rollsRoyceCorp)
          )
        : [];

    let honeywellFiltered =
      0 < state.honeywellSelections.length
        ? products.filter(
            p => p.honeywell && state.honeywellSelections.includes(p.honeywell)
          )
        : [];

    let safranFiltered =
      0 < state.safranSelections.length
        ? products.filter(
            p => p.safran && state.safranSelections.includes(p.safran)
          )
        : [];

    let allFilteredProducts = cmFiltered.concat(
      amsFiltered,
      prattAndWhitneyFiltered,
      generalElectricFiltered,
      rollsRoycePlcFiltered,
      rollsRoyceCorpFiltered,
      honeywellFiltered,
      safranFiltered
    );

    return _.uniq(allFilteredProducts);
  } else {
    // no filters set, return everything
    return products;
  }
}
